import MD5 from "md5";

export const providerLogin = (res) => {
  const tenantId = res?.tenantId;
      const payload = JSON.stringify({
        provider: res?.provider,
        email: res?.user?.email,
        name: res?.user?.displayName,
        token: res?.credential.accessToken,
        tenantId: tenantId,
      });
      const url = process.env.REACT_APP_FETCH_URL + "/socmed_auth";

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      })
      .then((result) => result.json())
      .then((result) => {
        if (result && result?.isAuthenticate) {
          localStorage.setItem("token", result.token);
          localStorage.setItem("name", result.name);
          localStorage.setItem("a01c12", tenantId);
        }

        return result;
      });
}

export const getPijarUser = async (res) => {
  const tenantId = res?.tenantId;
  const url = process.env.REACT_APP_FETCH_URL + "/pijar/check-user/" + res?.userId;
  
  return await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res)=> res.json())
  .then((res) => {
    if (res.code === 200) {
      const userData = res.data;
      const url = process.env.REACT_APP_FETCH_URL + "/socmed_auth";
      const payload = JSON.stringify({
        provider: "pijar",
        email: userData.email,
        name: userData.name,
        token: MD5(new Date()),
        tenantId: tenantId,
      });

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      })
      .then((result) => result.json())
      .then((result) => {
          if (result && result?.isAuthenticate) {
            localStorage.setItem("token", result.token);
            localStorage.setItem("name", result.name);
            localStorage.setItem("a01c12", tenantId);

            setTimeout(() => {
              window.location.href = "/";
            }, 500);
          }
      });
    }
  })
}